import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useCallback } from "react";

/**
 * Custom hook for reCAPTCHA v3 verification
 * Must be used inside a RecaptchaWrapper or GoogleReCaptchaProvider
 * @returns {Object} - verifyRecaptcha function and ready state
 */
export function useRecaptcha() {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const verifyRecaptcha = useCallback(
    async (action) => {
      if (!executeRecaptcha) {
        return null;
      }

      try {
        const token = await executeRecaptcha(action);
        return token;
      } catch (error) {
        return null;
      }
    },
    [executeRecaptcha]
  );

  return {
    executeRecaptcha: verifyRecaptcha,
    isReady: !!executeRecaptcha,
  };
}
